var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading || _vm.showSpinner)?_c('div',[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"semipolar-spinner"},[_c('div',{staticClass:"ring"}),_c('div',{staticClass:"ring"}),_c('div',{staticClass:"ring"}),_c('div',{staticClass:"ring"}),_c('div',{staticClass:"ring"})])
}]

export { render, staticRenderFns }